import API from './lib/api'
export default new API();
